import React from 'react';

export const CALCULATOR_SECTION_TITLE_DEFAULT = (
    <>
        Ready To Fix Your <strong>Finances</strong>?
    </>
);

export const CALCULATOR_SECTION_SUBTITLE_DEFAULT = 'Bad credit? Too much debt? Let us help you!';
